import { styled } from "styled-components";

export const CountWrapper = styled.div`
  margin-top: 4px;
  font-size: 12px;
  font-weight: bold;
`;
